const toNumber = (value) => Number(value || 0);

// For TC invoices: Gross = Base + Tax, Tax = tax percent * Base
// Commission is now calculated on Gross, Net = Gross - Commission
export const getTCInvoiceAmounts = (invoice) => {
  const baseAmount = toNumber(invoice?.inv_amount); // treat inv_amount as base
  const taxRate = toNumber(invoice?.commission_tax_rate); // use commission_tax_rate as tax percent
  const taxAmount = baseAmount * taxRate;
  const grossAmount = baseAmount + taxAmount;
  const commissionRate = toNumber(invoice?.commission_rate);
  // Commission is now % of gross amount
  const commissionAmount = grossAmount * commissionRate;
  const totalDeductions = 0; // No other deductions
  // Net amount is gross minus commission
  const netAmount = grossAmount - commissionAmount;

  return {
    baseAmount,
    taxRate,
    taxAmount,
    grossAmount,
    commissionRate,
    commissionAmount,
    totalDeductions,
    netAmount,
  };
};